var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{desktop: !_vm.isMobile, mobile: _vm.isMobile},attrs:{"id":"tabs"}},_vm._l((_vm.items),function(item){return _c('a',{key:item.id,staticClass:"tab",class:{selected: item.selected},on:{"click":function($event){return _vm.onClick(item)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }